/*
 The iframe we're interested in appears in a different place in the DOM
 depending on whether we're seeing the page directly in Drupalgem or via
 an additional level of iframe in Vulcan.

 Try both options until we find what we're looking for.
 */
const $iframeData = (() => {
  const selectors = [
    // Visiting Drupal directly
    'div.clinical-reality iframe',
    // Loading via Vulcan
    'iframe[src^="/iframe/node"]'
  ];

  for (const selector of selectors) {
    const element = $(selector, window.parent.document);

    if (element.length > 0) {
      return element;
    }
  }

  console.warn('Failed to find clinicalreality iframe; cannot start.');

  return null;
})();
var settings = Drupal.settings.globals_variables || {};
var $landingVideo = $('.js-ccr-landing-video');
var $landingPage = $('.js-ccr-landing-page');
var $landingIframe = $('.js-ccr-landing-iframe');
var $introVideo = $('.js-intro-video');
var $analysisCta = $('.js-start-analysis');
var $body = $('body');
var $html = $('html');
var isMobile = $body.hasClass('device-mobile');
var isStartAnalysisClicked = false;
var $cnContainer = $('.content_container');
var language = $html.attr('lang');
var $head = $('head');
var displayCCRToolCta;
var displayCCRTool;
var selectChildIframe;
var prevHashValue = '';
var hashValue;
var $iframes;
var pathName;
var prevURL;
var $trackElement;
var languageValue;
var mediaQueryRange;
var $videoSource;
var postIframeResults;
var eventMethod;
var eventer;
var messageEvent;
var eventData;
var messageType;
var userSignedIn;
var isLoyaltyMember;
var siteUrlLoyalty;
var validLoyaltyName;
var loyaltyOffer;
var paramObj;
var setIframeLanguage;
var generateLocaleSrc;
var sendPostMessage;
var processPostMessageAction;
var initIframeResize;

// If there is no intro video then show start analysis block
if ($landingPage.hasClass('js-no-intro-video')) {
  window.top.location.hash = 'StartAnalysis';
}

(function ($, ElcServiceBus, ServiceBusTopics, site, generic) {
  /**
   * Virtual Try On landing page Formatter
   */
  var topics = ServiceBusTopics || window.ServiceBusTopics;
  var serviceBus = ElcServiceBus || window.ElcServiceBus;

  /**
    *  Adding class to display the intro-video & Iframe
    *  in full viewport for Mobile view.
  */
  $body.addClass('full-viewport');

  // Display CCR tool landing content which has CTA to start analysis
  displayCCRToolCta = function () {
    $landingVideo.removeClass('active');
    $landingPage.removeClass('active');
    $landingIframe.removeClass('active');
    $body.removeClass('full-viewport');
  };
  // Display CCR tool which has iframe embeded
  displayCCRTool = function () {
    $iframeData.contents().find('.js-ccr-landing-video').removeClass('active');
    $iframeData.contents().find('.js-ccr-landing-page').removeClass('active');
    $iframeData.contents().find('.js-ccr-landing-iframe').addClass('active');
    $iframeData.contents().find('body').addClass('full-viewport');
  };

  // Select the Child iframe in landing page
  selectChildIframe = function () {
    $iframes = $landingIframe.children('iframe');
  };

  function loadVideoPc() {
    if (!isMobile) {
      // Utilize existing unison value
      mediaQueryRange = $head.css('font-family');
      $videoSource = $introVideo.children('source');
      if (mediaQueryRange.indexOf('usn-small-max') > -1) {
        // Ipad portrait
        $videoSource.each(function () {
          var $thisSrc = $(this);
          var srcValue = $thisSrc.attr('data-tab-src')
            ? $thisSrc.attr('data-tab-src')
            : $thisSrc.attr('data-pc-src');
          // Load tablet specific video if available or else pc video

          $thisSrc.attr('src', srcValue);
        });
      } else if (
        mediaQueryRange.indexOf('usn-medium-max') > -1 ||
        mediaQueryRange.indexOf('usn-large-max') > -1
      ) {
        // Ipad landscape and wider screen
        $videoSource.each(function () {
          var $thisSrc = $(this);
          // Load pc specific video

          $thisSrc.attr('src', $thisSrc.attr('data-pc-src'));
        });
      }
      // Since src is set using JS, we need to load the new video
      $introVideo.get(0).load();
    }
  }
  function setHashValue(currentHashValue) {
    if (currentHashValue === '' || currentHashValue === '#StartAnalysis') {
      /**
       * If hash is empty or start analysis, then
         show landing content 
      */
      displayCCRToolCta();
      /**
       * If we have progressed in the quiz, then
         reset the iframes, otherwise don't reset
      */
      if (isStartAnalysisClicked === true) {
        // Let's reset iframe
        selectChildIframe();
        $iframes.each(function () {
          $(this).attr('src', $(this).attr('data-src'));
        });
      }
    } else if (currentHashValue === '#Quiz') {
      // If hash is Quiz, then show quiz iframe
      displayCCRTool();
      selectChildIframe();
      $iframes.each(function () {
        $(this).attr('src', $(this).attr('data-src'));
      });
      $('.clinical-reality-iframe-v1').scrollIntoView();
    }
  }
  /**
   * With browser back button navigation user should
   * be able to visit different states in the quiz flow
  */
  window.top.addEventListener('hashchange', async function () {
    try {
      const locationObj = window.top.document.location;

      pathName = locationObj.pathname;
      prevURL = event?.originalEvent?.oldURL;
      if (prevURL) {
        prevURL = new URL(prevURL);
        prevHashValue = prevURL.hash;
      }

      if (pathName.indexOf('clinicalreality') > -1) {
        hashValue = locationObj.hash;

        /**
         * Corner case in which removing an element from cart (and after taking the Quiz)
         hashValue is reset with empty value.
         * Then, an early return is needed to prevent showing
         landing content or an unexpected iframe reset
        */
        if (prevHashValue === '#Quiz' && hashValue === '') {
          return;
        }
        setHashValue(hashValue);
      }
    } catch (error) {
      console.error('Error in handleHashChange: ', error);
    }
  });

  /**
   * IPad landscape mode or pc view should play 4X3 size video
   * iPad portrait mode should play 3X4 size video
   * only PC has this video switch and mobile will play its default video
  */
  // Do not show subtitle track for english language
  $trackElement = $introVideo.children('track');
  languageValue = language.split('-')[0];

  if (languageValue.toLowerCase().indexOf('en') > -1) {
    $trackElement.remove();
  }

  loadVideoPc();
  // Display landing page when the Intro video Playback ends
  $introVideo.once().on('ended', function () {
    displayCCRToolCta();
    document.location.hash = 'StartAnalysis';
  });

  // Display WIS image IFrame when the Start analysis CTA clicked
  $analysisCta.once().on('click', function () {
    isStartAnalysisClicked = true;
    displayCCRTool();
    window.top.location.hash = 'Quiz';
    if (isMobile && $landingIframe.is(':visible')) {
      $landingIframe.closest($cnContainer).addClass('clinicalreality-container');
    }
  });

  // By Default removing Class in $cnContainer
  if (isMobile && !$landingIframe.is(':visible')) {
    $landingIframe.closest($cnContainer).removeClass('clinicalreality-container');
  }

  /**
  * When quiz is complete, post the data and navigate to show
  * @return {type} results page
  */
  postIframeResults = function () {
    eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    eventer = window[eventMethod];
    messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
    eventer(
      messageEvent,
      function () {
        eventData = event.data;
        messageType = eventData.messageType;
        /**
        * Store the valid JSON response into a form and then submit
        * to view results page
        */
        if (typeof event.data === 'object' && messageType === 'Loyalty Event') {
          // Product video can be played after quiz results
          $.cookie('ccr_product_video_played', 0, { path: '/' });
          $('.js-ccr-results-form')
            .text(JSON.stringify(event.data))
            .closest('form')
            .trigger('submit');
          userSignedIn = parseInt(site.userInfoCookie.getValue('signed_in'), 10);
          isLoyaltyMember = parseInt(site.userInfoCookie.getValue('is_loyalty_member'), 10);
          siteUrlLoyalty = window.location.href;
          validLoyaltyName = 'clinicalreality';
          loyaltyOffer = settings.loyalty_clinique_reality_offer;

          // If the user is signed in and a loyalty member apply the Clinique Reality offer
          if (
            userSignedIn &&
            isLoyaltyMember &&
            siteUrlLoyalty.indexOf(validLoyaltyName) !== -1 &&
            loyaltyOffer
          ) {
            paramObj = {
              offer_code: loyaltyOffer,
              do_not_defer_messages: 1
            };

            generic.jsonrpc.fetch({
              method: 'offers.apply',
              params: [paramObj]
            });
          }
        } else if (messageType === 'analytics_event') {
          // Trigger analytics event
          site.track.evtLink({
            event_name: eventData.event_name,
            event_category: eventData.event_category,
            event_action: eventData.event_action,
            event_label: eventData.event_label,
            external_session_id: eventData.external_session_id
          });
        } else if (messageType === 'analytics_pageView') {
          // Trigger analytics page view
          site.track.evtView({
            page_type: eventData.page_type,
            page_url: eventData.page_url,
            page_name: eventData.page_name,
            boutique: eventData.boutique,
            external_session_id: eventData.external_session_id
          });
        }
      },
      false
    );
  };

  // Post values from quiz data
  postIframeResults();

  // Set iframe language
  setIframeLanguage = function () {
    var langPart = [];
    var langValue = '';

    $iframes = $('iframe', $landingIframe);

    if (language.indexOf('-e-') > -1) {
      // For sites like ca where languages are en, fr
      langPart = language.split('-e-');
    } else if (language.indexOf('-') > -1) {
      // For site with default en language
      langPart = language.split('-');
    } else {
      // For sites like fr
      langPart.push(language);
      langPart.push(Drupal.settings.ajaxPageState.theme.split('_')[0]);
    }
    // Should in format: EnUk
    langValue = langPart.map(function (val) {
      var langFormat = val.toLowerCase();

      return langFormat.replace(langFormat.charAt(0), langFormat.charAt(0).toUpperCase());
    });

    // CCR Image iframe URL should have languages in specific format
    $iframes.each(function () {
      var $this = $(this);
      var thisSrc = $this.attr('data-src');

      if (thisSrc.indexOf('&lang=') === -1) {
        $this.attr('data-src', thisSrc + '&lang=' + langValue.join(''));
      }
    });
  };

  setIframeLanguage();

  generateLocaleSrc = function (src) {
    const mpConfig = window.MP || {
      SrcLang: 'en'
    };
    const srcParts = src.split('/');
    const iframeId = srcParts.pop();
    let locale = $.cookie('LOCALE');
    let iframeSrc;

    locale =
      !locale && locale.indexOf(mpConfig.SrcLang) === -1
        ? locale.toLowerCase().replace('_', '-')
        : '';
    if (!locale) {
      iframeSrc = srcParts.join('/').concat('/').concat(locale.concat('-').concat(iframeId));
    }

    return iframeSrc;
  };
  sendPostMessage = ($iframe, action, resp) => {
    $iframe.get(0).contentWindow.postMessage(
      JSON.stringify({
        ... { _elc_action: action },
        ... resp
      }),
      '*'
    );
  };
  processPostMessageAction = async(self, $iframe, iframeData, action, data) => {
    switch (action) {
      case 'addtobag':
        $landingIframe = iframeData.contents().find('.js-ccr-landing-iframe');

        $(document).trigger('elc.iframe.addToBag', [$landingIframe, data]);
        break;
      case 'product.getProducts': {
        const PRODUCT_SERVICE_IS_GRAPHQL = true;
        let productData;
        const promises = {};

        try {
          if (data.productIds) {
            let queryOptions = {
              filterBy: {
                productIds: data.productIds
              }
            };

            if (data.queryOptions) {
              queryOptions = {
                ... data.queryOptions,
                ... queryOptions
              };
            }
            promises.products = serviceBus.query(
              topics.queries.GET_PRODUCT_DATA,
              queryOptions
            );
          }
          if (data.skuIds) {
            promises.skus = serviceBus.query(topics.queries.GET_SKUS, data.skuIds);
          }

          Promise.all([promises.products, promises.skus])
            .then(() => {
              productData = {
                _meta: {
                  graphql: PRODUCT_SERVICE_IS_GRAPHQL,
                  language: document.documentElement.getAttribute('lang'),
                  location: {
                    host: location.host,
                    pathname: location.pathname
                  }
                },
                products: data[0],
                skus: data[1]
              };
            })
            .catch((e) => {
              productData = e;
            })
            .finally(() => {
              sendPostMessage($iframe, action, productData);
            });
        } catch (e) {
          console.log(e);
        }
        break;
      }
      default:
    }
  };
  initIframeResize = function () {
    const self = window.top;
    const $iframeTemplates = $iframeData.contents().find('.js-ccr-landing-iframe iframe:not(.attached)');

    if ($iframeTemplates.length) {
      $iframeTemplates.each(function () {
        const $this = $(this);
        let src = $this.data('src');

        if ($this.data('dynamicSrc')) {
          src = generateLocaleSrc(src);
        }
        $this.attr('src', src);
        $this.addClass('attached');

        /* If viewing via Vulcan, the template iframe doesn't have an
           iFrameResize method.  Copy it from window.top to be sure. */
        $this.iFrameResize = window.top.iFrameResize;
        $this.iFrameResize({
          sizeHeight: false,
          autoResize: false,
          scrolling: true,
          heightCalculationMethod: 'bodyScroll',
          onMessage: function (response) {
            if (!response) {
              return false;
            }
            const data =
              typeof response['message'] === 'string'
                ? JSON.parse(response['message'])
                : response['message'];
            const action = data['_elc_action'];

            $this.trigger('iframe.message', [data]);

            delete data['_elc_action'];
            processPostMessageAction(self, $this, $iframeData, action, data);
          }
        });
      });
    }
  };

  window.top.addEventListener('load', () => {
    if (typeof window.top['iFrameResize'] === 'function') {
      initIframeResize();
    }
  });
})(jQuery, Drupal, window.ElcServiceBus || false, window.ServiceBusTopics || false);
